import { apiFuns } from "sw-hic";

const api = {
  PxySetting: apiFuns.genStandard("pxySetting", "/api/md"),
};

export default api;
